import { IconButtonProps } from '@chakra-ui/react';
import { useState } from 'react';
import { IconButton } from 'components/UI';

export type ActionLoadingCallback = (isLoading?: boolean) => void;

export type ActionCallback = (cb: ActionLoadingCallback) => void;

type ActionProps = Omit<IconButtonProps, 'aria-label'> & {
  callback: ActionCallback;
  iconComponent: React.ElementType;
  loading?: boolean;
  disabled?: boolean;
  filtering?: boolean;
  title: string;
  className?: string;
};

const Action = ({
  iconComponent: IconComponent,
  callback = () => {},
  loading = false,
  disabled = false,
  filtering = false,
  title,
  ...props
}: ActionProps) => {
  const [inlineLoading, setInlineLoading] = useState(false);

  const filteringProps = filtering
    ? {
        boxShadow: 'inset -4px -4px 4px rgba(0, 0, 0, 0.55) !important',
      }
    : {};

  return (
    <IconButton
      {...props}
      {...filteringProps}
      isLoading={loading || inlineLoading}
      onClick={() => {
        callback((isLoading?: boolean) => {
          setInlineLoading(isLoading ?? false);
        });
      }}
      title={title}
      aria-label={title}
      disabled={disabled || inlineLoading || loading}
      icon={<IconComponent />}
    />
  );
};

export default Action;
